import { render, staticRenderFns } from "./ClientQuestionsTab.vue?vue&type=template&id=5cadc350&scoped=true"
import script from "./ClientQuestionsTab.vue?vue&type=script&lang=js"
export * from "./ClientQuestionsTab.vue?vue&type=script&lang=js"
import style0 from "./ClientQuestionsTab.vue?vue&type=style&index=0&id=5cadc350&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cadc350",
  null
  
)

export default component.exports